import React, { useState, useRef } from "react";

import { LoyaltyCard } from "../card/LoyaltyCard";
import { LoyaltyList } from "../list/LoyaltyList";
// Styled
import { Carousel } from "./LoyaltyCarousel.styled";

export const LoyaltyCarousel = ({ cardList }) => {

   const cards = cardList ? cardList : [];

   const itemsRef = useRef([]);

   const [cardSelected, setCardSelected] = useState(0);

   const onHandleSelectCard = (index) => {
      itemsRef.current[index].scrollIntoView({
         behavior: 'smooth',
         block: 'center',
         inline: 'center'
      });

      setCardSelected(index);
   }

   return (
      <>
         <Carousel>
            {
               cards.map((card, index) => (
                  <LoyaltyCard
                     ref={el => itemsRef.current[index] = el}
                     key={index}
                     card={card}
                     selected={cardSelected === index}
                     onClick={() => onHandleSelectCard(index)}
                  />
               ))
            }
         </Carousel>
         <LoyaltyList historyList={cards[cardSelected].points}/>
      </>

   )

}